export default __webpack_public_path__ + "static/media/upgrade-report7.0fbfc358.png";